import script from "./ChangeStageStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeStageStatus.vue?vue&type=script&setup=true&lang=js"

import "./ChangeStageStatus.vue?vue&type=style&index=0&id=4ca6a7a6&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca6a7a6"]])

export default __exports__